import { Math } from 'phaser';

const DIRECTIONS = {
  UP: 0,
  DOWN: 1,
  LEFT: 2,
  RIGHT: 3
};

export const lightstickHandler = (character, nameCharacter) => {
    character.anims.play(`lightstick-${nameCharacter}`, true);
};

let lastMovement = 'down';
let direction = [];

export const setLastMovement = (lastMovementCheck) => {
  lastMovement = lastMovementCheck;
};

export const getLastMovement = () => {
  return lastMovement;
};

export const walkHandler = (cursors, character, speed, nameCharacter, hasLightstick, moveAlone = false, ignoreCursors = false) => {
  if(!ignoreCursors) {
    if (cursors.left.isDown) {
        character.setVelocity(-speed, 0);
        lastMovement = 'left';
        character.anims.play(`left-${nameCharacter}`, true);
      } else if (cursors.right.isDown) {
          character.setVelocity(speed, 0);
          lastMovement = 'right';
          character.anims.play(`right-${nameCharacter}`, true);
      } else if(cursors.up.isDown) {
          lastMovement = 'up';
  
        character.anims.play(`up-${nameCharacter}`, true);
        character.setVelocity(0, -speed)
      } else  if(cursors.down.isDown) {
          lastMovement = 'down';
  
        character.anims.play(`down-${nameCharacter}`, true);
        character.setVelocity(0, speed)
      } else {
          if(moveAlone) {
            character.anims.play(`right-${nameCharacter}`, true);
            character.setVelocity(0, 0);
            
          } else {
            character.setVelocity(0, 0);
    
            if(!hasLightstick) {
              switch(lastMovement) {
                case 'up':
                  // character.anims.play(`up-static-${nameCharacter}`, true);
                  character.anims.play(`repose-${nameCharacter}`, true);
  
                  break;
                case 'down':
                  character.anims.play(`repose-${nameCharacter}`, true);
                  break;
                case 'left':
                  character.anims.play(`repose-${nameCharacter}`, true)
                  break;
                case 'right':
                  character.anims.play(`repose-${nameCharacter}`, true);
                  break;
                default:
                  character.anims.play(`repose-${nameCharacter}`, true);
                  break;
              }
            } else {
              lightstickHandler(character, nameCharacter);
            }
  
          }
      }

  }
};

export const directionHandler = (character, speed, nameCharacter) => {
  if(!direction[nameCharacter]) {
    direction[nameCharacter] = DIRECTIONS.UP;
  }
  switch (direction[nameCharacter]){
    case DIRECTIONS.UP:
      character.anims.play(`up-${nameCharacter}`, true);
      character.setVelocity(0, -speed)
      break

    case DIRECTIONS.DOWN:
      character.anims.play(`down-${nameCharacter}`, true);
      character.setVelocity(0, speed)
      break

    case DIRECTIONS.LEFT:
      character.anims.play(`left-${nameCharacter}`, true);
      character.setVelocity(-speed, 0)
      break

    case DIRECTIONS.RIGHT:
      character.anims.play(`right-${nameCharacter}`, true);
      character.setVelocity(speed, 0)
      break
  }
};

export const randomDirection = (character) => {
	let newDirection = Math.Between(0, 3);
	while (newDirection === direction[character]){
    newDirection = Math.Between(0, 3);
	}

	direction[character] = newDirection;
};

// module.exports = {
//     walkHandler,
//     directionHandler,
//     randomDirection,
//     lightstickHandler
// };
